class FeatureFlags {
  /**
   * @param {Array} features[String|Object]
   *   features[String] Used for both the `name` and the lookup `key` of the feature.
   *   features[Object] Explicitly provide `name` and `key`. ex { name: "myFeature", key: ["someOtherKey"] }
   */
  constructor(features) {
    features.forEach(feature => {
      const {
        name,
        key,
        defaultState,
        require = "any"
      } = feature instanceof Object ? feature : {
        name: feature,
        key: feature,
        defaultState: false,
        require: "any"
      };

      if (feature instanceof Object && typeof name === "undefined") {
        throw new Error("Feature flags configured incorrectly, name must be defined on feature flag objects");
      }

      if (feature instanceof Object && typeof key === "undefined") {
        this[name] = () => this.isEnabled([name], defaultState, require);
      } else {
        const keys = Array.isArray(key) ? key : [key];

        this[name] = () => this.isEnabled(keys, defaultState, require);
      }
    });
  }
  /**
   * Convenience method to instantiate a new FeatureFlags object
   */


  static define(features) {
    return new FeatureFlags(features);
  }
  /**
   * Default lookup function to find the feature value.
   * @param {String} key
   */


  lookup(key) {
    var _document;

    const cookie = (_document = document) === null || _document === void 0 ? void 0 : _document.cookie;

    if (!cookie) {
      return null;
    }

    if (cookie.includes(`${key}=true`)) {
      return "true";
    }

    if (cookie.includes(`${key}=false`)) {
      return "false";
    }

    return null;
  }
  /**
   * Override the default `lookup` function.
   * @param {Function} lookupFunction A function that returns a `value` for the given `key`.
   */


  setCustomLookupFunction(lookupFunction) {
    this.lookup = lookupFunction;
  }
  /**
   * Lookup the given keys and test if the value is "true", which tells us the feature is turned on.
   * @param {String} keys
   * @param {String} defaultState
   * @param {String} require  if set to "all", then all of the keys must be true
   */


  isEnabled(keys, defaultState, require) {
    let enabledValue = false;

    for (const lookupKey of keys) {
      const lookupUpValue = this.lookup(lookupKey);

      if (lookupUpValue === null) {
        enabledValue = defaultState;
      } else {
        enabledValue = lookupUpValue === "true";
      }

      if (enabledValue && require !== "all") {
        break;
      }
    }

    return enabledValue;
  }

}

export default FeatureFlags;
//# sourceMappingURL=index.js.map
